import { Grid } from "antd";
import { useLayout } from "../../context/LayoutContext";
import ContentWrapper from "../../layouts/components/ContentWrapper";
import { ChangePassword, ProfileEditor } from "./components";
import styles from "./styles.module.scss";

const Profile: React.FC = () => {
  const { useBreakpoint } = Grid;
  const { getLeftSiderWidth } = useLayout();
  const screens = useBreakpoint();
  return (
    <ContentWrapper>
      <div
        className={`${styles.container} ${screens.md ? "" : styles.small}`}
        style={{ gap: screens.xs ? "4px" : "24px" }}
      >
        <ProfileEditor />
        <ChangePassword />
      </div>
    </ContentWrapper>
  );
};

export default Profile;
